// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__dialog--PfYGG {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 25rem;
}
.style__titleIcon--hQPd1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 3rem;
  border-radius: 1.5rem;
  background-color: #e5f9ff;
  color: #1287b8;
  padding: 1rem;
}
.style__titleIcon--hQPd1 > svg {
  overflow: initial !important;
}
.style__inputBox--rJY7A {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.style__inputFieldBox--Nize0 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #7d8287;
}
.style__inputField--GbHrG {
  color: #7d8287 !important;
  height: 3rem;
  border-radius: 0.5rem !important;
}
.style__inputField--GbHrG .MuiOutlinedInput-notchedOutline legend {
  max-width: 0.01px;
}
.style__inputField--GbHrG > p {
  margin-top: 0 !important;
}
.style__inputFieldMenu--b54JL li {
  height: 2.5rem;
}
.style__autocompleteFieldMenu--gV34W > ul > div {
  height: 2.5rem;
}
.style__detailsBox--tbxgp {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.style__detailsItem--ShFRb {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  color: #626a65;
}
.style__dialogActions--E6pq8 {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.style__dialogDefaultActionBox--_xNwv {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
}
.style__booleanInput--o6T4p {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-content: center;
}
.style__booleanInputDisabled--hGY3v {
  opacity: 0.5;
}
.style__toggle--d_jf5 {
  padding-top: 0.1875rem;
}
.style__iconSelect--CycT_ {
  margin-right: 1rem;
}
.style__deleteButton--EFfix {
  color: #d72a1d;
}
.style__loadingBox--CXydA {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
}
.style__loadingBox--CXydA svg {
  color: #04AFF9;
}
.style__confirmActionButton--HMla6 {
  background-color: #26c1f3 !important;
  min-width: 8.5rem;
}
.style__confirmActionButton--HMla6:hover, .style__confirmActionButton--HMla6:focus, .style__confirmActionButton--HMla6:active {
  background-color: #1287b8 !important;
}
.style__confirmActionButton--HMla6:disabled {
  background-color: #26c1f3 !important;
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./../components/src/FormDialog/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAHJ;AAFA;EASI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;AAJJ;AAbA;EAoBM,4BAAA;AAJN;AAhBA;EAyBI,aAAA;EACA,sBAAA;EACA,YAAA;AANJ;AArBA;EA+BI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAPJ;AA3BA;EAsCI,yBAAA;EACA,YAAA;EACA,gCAAA;AARJ;AAhCA;EA2CM,iBAAA;AARN;AAnCA;EA+CM,wBAAA;AATN;AAtCA;EAqDM,cAAA;AAZN;AAzCA;EA2DM,cAAA;AAfN;AA5CA;EAgEI,aAAA;EACA,sBAAA;EACA,YAAA;AAjBJ;AAjDA;EAsEI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAlBJ;AAvDA;EA6EI,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;AAnBJ;AA7DA;EAoFI,aAAA;EACA,mBAAA;EACA,YAAA;AApBJ;AAlEA;EA0FI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AArBJ;AAxEA;EAiGI,YAAA;AAtBJ;AA3EA;EAqGI,sBAAA;AAvBJ;AA9EA;EAyGI,kBAAA;AAxBJ;AAjFA;EA6GI,cAAA;AAzBJ;AApFA;EAiHI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA1BJ;AA1FA;EAuHM,cAAA;AA1BN;AA7FA;EA4HI,oCAAA;EACA,iBAAA;AA5BJ;AA8BI;EAGE,oCAAA;AA5BN;AA+BI;EACE,oCAAA;EACA,aAAA;AA7BN","sourcesContent":["@import '../colors';\n@import '../spacing';\n\n:local {\n  .dialog {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    min-width: 25rem;\n  }\n\n  .titleIcon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: @spacing-300;\n    width: @spacing-300;\n    border-radius: @spacing-150;\n    background-color: @color-light-blue-099;\n    color: @color-light-blue-050;\n    padding: @spacing-100;\n\n    > svg {\n      overflow: initial !important;\n    }\n  }\n\n  .inputBox {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n\n  .inputFieldBox {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n    color: @color-asphalt-grey-050;\n  }\n\n  .inputField {\n    color: @color-asphalt-grey-050 !important;\n    height: @spacing-300;\n    border-radius: @spacing-50 !important;\n\n    :global(.MuiOutlinedInput-notchedOutline legend) {\n      max-width: 0.01px;\n    }\n\n    > p {\n      margin-top: 0 !important;\n    }\n  }\n\n  .inputFieldMenu {\n    li {\n      height: @spacing-250;\n    }\n  }\n\n  .autocompleteFieldMenu {\n    > ul > div {\n      height: @spacing-250;\n    }\n  }\n\n  .detailsBox {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n\n  .detailsItem {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    color: @color-pewter-grey-040;\n  }\n\n  .dialogActions {\n    margin-top: @spacing-75;\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n\n  .dialogDefaultActionBox {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n  }\n\n  .booleanInput {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    align-content: center;\n  }\n\n  .booleanInputDisabled {\n    opacity: 0.5;\n  }\n\n  .toggle {\n    padding-top: 0.1875rem;\n  }\n\n  .iconSelect {\n    margin-right: @spacing-100;\n  }\n\n  .deleteButton {\n    color: @color-red-050;\n  }\n\n  .loadingBox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: @spacing-200 0;\n\n    svg {\n      color: @color-light-blue-neon;\n    }\n  }\n\n  .confirmActionButton {\n    background-color: @color-light-blue-070 !important;\n    min-width: 8.5rem;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: @color-light-blue-050 !important;\n    }\n\n    &:disabled {\n      background-color: @color-light-blue-070 !important;\n      opacity: 0.85;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `style__dialog--PfYGG`,
	"titleIcon": `style__titleIcon--hQPd1`,
	"inputBox": `style__inputBox--rJY7A`,
	"inputFieldBox": `style__inputFieldBox--Nize0`,
	"inputField": `style__inputField--GbHrG`,
	"inputFieldMenu": `style__inputFieldMenu--b54JL`,
	"autocompleteFieldMenu": `style__autocompleteFieldMenu--gV34W`,
	"detailsBox": `style__detailsBox--tbxgp`,
	"detailsItem": `style__detailsItem--ShFRb`,
	"dialogActions": `style__dialogActions--E6pq8`,
	"dialogDefaultActionBox": `style__dialogDefaultActionBox--_xNwv`,
	"booleanInput": `style__booleanInput--o6T4p`,
	"booleanInputDisabled": `style__booleanInputDisabled--hGY3v`,
	"toggle": `style__toggle--d_jf5`,
	"iconSelect": `style__iconSelect--CycT_`,
	"deleteButton": `style__deleteButton--EFfix`,
	"loadingBox": `style__loadingBox--CXydA`,
	"confirmActionButton": `style__confirmActionButton--HMla6`
};
export default ___CSS_LOADER_EXPORT___;
